<template>
  <div class="print">
    <section class="page-break">
      <table>
        <colgroup>
          <col width="160"/>
          <col width="220"/>
          <col width="800"/>
          <col width="100"/>
          <col width="100"/>
          <col width="100"/>
          <col width="100"/>
        </colgroup>
        <tr>
          <th class="gray">{{ $t("회사명") }}</th>
          <td>{{ form.stdInfo.field_name }}</td>
          <td rowspan="5">
            <span class="print-title"><span style="color: #0029ff">[{{$t('정기')}}]</span> {{$t('위험성평가표')}}(MIRAS)</span>
          </td>
          <th colspan="4" class="gray">{{ $t("확인자") }}</th>
        </tr>
        <tr>
          <th class="gray">{{ $t("공정명") }}</th>
          <td>{{ form.inputB_2 }}</td>
          <th class="gray">{{ $t("작성자") }}</th>
          <th class="gray">{{ $t("검토자") }}</th>
          <th class="gray">{{ $t("회람자") }}</th>
          <th class="gray">{{ $t("승인자") }}</th>
        </tr>
        <tr>
          <th class="gray">{{ $t("작업내용") }}</th>
          <td>{{ form.inputB_3 }}</td>
          <td rowspan="3" style="vertical-align: middle; height: 100px;">
            <div class="signature-container">
              <img
                v-if="form.sign1.sign"
                :src="form.sign1.sign"
                class="signature-image"
              />
            </div>
          </td>
          <td rowspan="3" style="vertical-align: middle; height: 100px;">
            <div class="signature-container">
              <img
                v-if="form.sign2.sign"
                :src="form.sign2.sign"
                class="signature-image"
              />
            </div>
          </td>
          <td rowspan="3" style="vertical-align: middle; height: 100px;">
            <div class="signature-container">
              <img
                v-if="form.sign3.sign"
                :src="form.sign3.sign"
                class="signature-image"
              />
            </div>
          </td>
          <td rowspan="3" style="vertical-align: middle; height: 100px;">
            <div class="signature-container">
              <img
                v-if="form.sign4.sign"
                :src="form.sign4.sign"
                class="signature-image"
              />
            </div>
          </td>
        </tr>
        <tr>
          <th class="gray">{{ $t("평가일") }}</th>
          <td>{{ form.inputB_4 }}</td>
        </tr>
        <tr>
          <th class="gray">{{ $t("작성일") }}</th>
          <td>{{ form.stdInfo.date }}</td>
        </tr>
      </table>

      <table class="mt-auto">
        <colgroup>
          <col width="130" />
          <col width="130" />
          <col width="130" />
          <col width="130" />
          <col width="130" />
          <col width="70" />
          <col width="70" />
          <col width="90" />
          <col width="130" />
          <col width="70" />
          <col width="70" />
          <col width="90" />
        </colgroup>
        <thead>
          <tr>
            <th colspan="12" class="text-left">❶ {{$t('위험성평가표')}}</th>
          </tr>
          <tr>
            <th rowspan="2">{{$t('세부작업명')}}</th>
            <th rowspan="2">{{$t('평가구분')}}</th>
            <th rowspan="2">{{$t('유해·위험요인')}}</th>
            <th rowspan="2">{{$t('재해형태')}}</th>
            <th rowspan="2">{{$t('현재 안전보건조치')}}</th>
            <th colspan="3">{{$t('현재 위험도')}}</th>
            <th rowspan="2">{{$t('위험감소대책')}}</th>
            <th colspan="3">{{$t('개선후 위험도')}}</th>
          </tr>
          <tr>
            <th>{{$t('가능성')}}</th>
            <th>{{$t('중대성')}}</th>
            <th>{{$t('위험도')}}</th>
            <th>{{$t('가능성')}}</th>
            <th>{{$t('중대성')}}</th>
            <th>{{$t('위험도')}}</th>
          </tr>
        </thead>
        <tbody>
        <tr v-if="form.riskAppraisalList.length === 0">
          <td colspan="12" class="text-left">{{ $t('작성된 내용이 없습니다.') }}</td>
        </tr>
        <template v-else>
          <tr v-for="(item, index) in form.riskAppraisalList" :key="`risk_${index}`">
            <td class="text-left">{{ item.input_1 }}</td>
            <td>{{ item.input_2 }}</td>
            <td>{{ item.input_4 }}</td>
            <td>{{ item.input_3 && item.input_3.startsWith('직접입력') ? item.input_3.substring(5) : $t(item.input_3) }}</td>
            <td class="text-left">{{ item.input_5 }}</td>
            <td>{{ item.input_6 }}</td>
            <td>{{ item.input_7 }}</td>
            <td :style="{ color: getRiskColor(item.input_8) }">{{ getResultRisk(item.input_8) }}{{ item.input_8 ? `(${item.input_6 * item.input_7})` : '' }}</td>
            <td class="text-left">{{ item.input_9 }}</td>
            <td>{{ item.input_11 }}</td>
            <td>{{ item.input_12 }}</td>
            <td :style="{ color: getRiskColor(item.input_13) }">{{ getResultRisk(item.input_13) }}{{ item.input_13 ? `(${item.input_11 * item.input_12})` : '' }}</td>
          </tr>
        </template>
        </tbody>
      </table>
    </section>

    <section class="page-break">
      <table class="mt-auto">
        <colgroup>
          <col width="260"/>
          <col />
          <col width="70" />
          <col width="70" />
          <col width="90" />
          <col width="150" />
          <col width="260"/>
        </colgroup>
        <thead>
        <tr>
          <th colspan="7" class="text-left">❷ {{$t('안전·보건관리자 검토의견')}}</th>
        </tr>
        <tr>
          <th rowspan="2">{{$t('세부작업명')}}</th>
          <th rowspan="2">{{$t('검토의견')}}</th>
          <th colspan="3">{{$t('검토의견 반영 위험도')}}</th>
          <th rowspan="2">{{$t('검토자')}}</th>
          <th rowspan="2">{{$t('비고')}}</th>
        </tr>
        <tr>
          <th>{{ $t('가능성') }}</th>
          <th>{{ $t('중대성') }}</th>
          <th>{{ $t('위험도') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="form.riskAppraisalList2.length === 0">
          <td colspan="7" class="text-left">{{$t('작성된 내용이 없습니다.')}}</td>
        </tr>
        <template v-else>
          <tr v-for="(item, index) in form.riskAppraisalList2" :key="`risk2_${index}`">
            <td>{{ item.input1 }}</td>
            <td class="text-left">{{ item.input2 }}</td>
            <td>{{ item.input3 }}</td>
            <td>{{ item.input4 }}</td>
            <td :style="{ color: getRiskColor(item.input5) }">{{ item.input5 }}</td>
            <td>{{ item.input6 }}</td>
            <td class="text-left">{{ item.input7 }}</td>
          </tr>
        </template>
        </tbody>
      </table>
    </section>

    <section class="page-break">
      <table class="mt-auto">
        <colgroup>
          <col width="50"/>
          <col />
          <col />
          <col width="50"/>
          <col />
          <col />
        </colgroup>
        <thead>
        <tr>
          <th colspan="6" class="text-left">❸ {{$t('개선현황')}}</th>
        </tr>
        <tr>
          <th>No.</th>
          <th>{{$t('조치 전 사진')}}</th>
          <th>{{$t('조치 후 사진')}}</th>
          <th>No.</th>
          <th>{{$t('조치 전 사진')}}</th>
          <th>{{$t('조치 후 사진')}}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="form.photoList.length === 0 && form.photoListAfter.length === 0">
          <td colspan="6" class="text-left">{{$t('작성된 내용이 없습니다.')}}</td>
        </tr>
        <template v-else>
          <tr v-for="(row, rowIndex) in photoRows" :key="`photo_row_${rowIndex}`">
            <th>{{ row.idx1 }}</th>
            <td>
              <div class="photo-container">
                <img
                  v-if="row.photo1Path"
                  :src="row.photo1Path"
                  class="photo-image"
                />
                <span v-else></span>
              </div>
            </td>
            <td>
              <div class="photo-container">
                <img
                  v-if="row.photoAfter1Path"
                  :src="row.photoAfter1Path"
                  class="photo-image"
                />
                <span v-else></span>
              </div>
            </td>

            <th>{{ row.idx2 }}</th>
            <td>
              <div class="photo-container">
                <img
                  v-if="row.photo2Path"
                  :src="row.photo2Path"
                  class="photo-image"
                />
                <span v-else></span>
              </div>
            </td>
            <td>
              <div class="photo-container">
                <img
                  v-if="row.photoAfter2Path"
                  :src="row.photoAfter2Path"
                  class="photo-image"
                />
                <span v-else></span>
              </div>
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </section>
  </div>
</template>

<script>
export default {
  name: "Print",
  props: {
    isPrint: Boolean,
    board: Object,
    form: Object,
  },
  computed: {
    photoRows() {
      const maxLen = Math.max(this.form.photoList.length, this.form.photoListAfter.length);
      const rows = [];
      const getPath = (item) => (item && item.image && item.image.path) ? item.image.path : null;
      for (let i = 0; i < maxLen; i += 2) {
        rows.push({
          idx1: i + 1,
          photo1Path: getPath(this.form.photoList[i]),
          photoAfter1Path: getPath(this.form.photoListAfter[i]),
          idx2: i + 2,
          photo2Path: getPath(this.form.photoList[i + 1]),
          photoAfter2Path: getPath(this.form.photoListAfter[i + 1]),
        });
      }
      return rows;
    }
  },
  methods: {
    getResultRisk(data) {
      switch (data) {
        case "A":
          return this.$t("매우높음");
        case "B":
          return this.$t("높음");
        case "C":
          return this.$t("약간높음");
        case "D":
          return this.$t("보통");
        case "E":
          return this.$t("낮음");
        case "F":
          return this.$t("매우낮음");
        default:
          return data;
      }
    },
    getRiskColor(risk) {
      switch (risk) {
        case "A":
        case "B":
        case "C":
        case "D":
        case "보통":
        case "약간높음":
        case "높음":
        case "매우높음":
          return "#E42728"; // red
        case "E":
        case "낮음":
          return "#FF8510"; // orange
        case "F":
        case "매우낮음":
          return "#28C76F"; // green
        default:
          return "#000"; // black
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.print {
  .print-title {
    font-size: 32px;
    font-weight: 700;
    color: #000;
    text-align: center;
    padding: 20px 0;
  }
  .division-title {
    font-size: 24px;
    font-weight: 700;
    color: #000;
    padding: 1.25rem 0rem;
  }

  .signature-container {
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;

    .signature-image {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 80px;
      object-fit: contain;
      display: block;
    }
  }

  .photo-container {
    width: 100%;
    min-height: 100px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;

    .photo-image {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 280px;
      object-fit: contain;
      display: block;
    }
  }

  table {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
    margin-bottom: 40px;

    th,
    td {
      border: 1px solid #757575;
      text-align: center;
      font-size: 18px;
      padding: 10px;
    }
    th {
      background-color: #ececec;
      font-weight: 500;
      word-break: keep-all;
    }
    td {
      min-width: 50px;
      word-break: keep-all;
      img {
        display: inline-block;
      }
    }
    .th-background {
      background-color: #ececec;
      white-space: nowrap;
    }
    .text-left {
      text-align: left;
      padding: 10px 14px;
    }
  }

  section:first-of-type > table:first-of-type {
    th, td {
      padding: 5px;
    }
  }
}

@media print {
  .page-break {
    page-break-inside: auto;
    page-break-after: always;
  }
  .page-break:last-child {
    page-break-after: auto;
  }
  table {
    page-break-inside: auto;
  }
  tr {
    page-break-inside: avoid;
    page-break-after: auto;
  }
}
</style>
